import { render } from "./PraticasAntissuborno.vue?vue&type=template&id=2c71763c&scoped=true"
import script from "./PraticasAntissuborno.vue?vue&type=script&lang=js"
export * from "./PraticasAntissuborno.vue?vue&type=script&lang=js"

import "./PraticasAntissuborno.vue?vue&type=style&index=0&id=2c71763c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c71763c"]])

export default __exports__